export const themeKeys = {
  THEME_DEFAULT: 'default',
  THEME_MID_ORANGE: 'mid-orange',
  THEME_JUICY_ORANGE: 'juicy-orange',
  THEME_MS_GREEN: 'ms-green',
  THEME_GRAPEY_GREEN: 'grapey-green',
  THEME_FOREST_GREEN: 'forest-green',
  THEME_OCEANY_BLUE: 'oceany-blue',
  THEME_WL_BLUE: 'wl-blue',
  THEME_PURPLY_PINK: 'purply-pink',
  THEME_REXY_PURPLE: 'rexy-purple',
  THEME_WATERMELONY_RED: 'watermelony-red',
} as const

export const themes = {
  [themeKeys.THEME_DEFAULT]: {
    header: 'bg-dusty-black-500',
    stats: 'bg-dusty-black-200',
  },
  [themeKeys.THEME_MID_ORANGE]: {
    header: 'bg-juicy-orange-400',
    stats: 'bg-deep-orange-50',
  },
  [themeKeys.THEME_JUICY_ORANGE]: {
    header: 'bg-juicy-orange-300',
    stats: 'bg-juicy-orange-100',
  },
  [themeKeys.THEME_MS_GREEN]: {
    header: 'bg-ms-green-300',
    stats: 'bg-ms-green-100',
  },
  [themeKeys.THEME_GRAPEY_GREEN]: {
    header: 'bg-grapey-green-300',
    stats: 'bg-grapey-green-100',
  },
  [themeKeys.THEME_FOREST_GREEN]: {
    header: 'bg-forest-green-300',
    stats: 'bg-forest-green-100',
  },
  [themeKeys.THEME_OCEANY_BLUE]: {
    header: 'bg-oceany-blue-300',
    stats: 'bg-oceany-blue-100',
  },
  [themeKeys.THEME_WL_BLUE]: {
    header: 'bg-wl-blue-250',
    stats: 'bg-wl-blue-100',
  },
  [themeKeys.THEME_PURPLY_PINK]: {
    header: 'bg-purply-pink-300',
    stats: 'bg-purply-pink-100',
  },
  [themeKeys.THEME_REXY_PURPLE]: {
    header: 'bg-rexy-purple-300',
    stats: 'bg-rexy-purple-100',
  },
  [themeKeys.THEME_WATERMELONY_RED]: {
    header: 'bg-watermelony-red-250',
    stats: 'bg-watermelony-red-50',
  },
}

export interface Box {
  category: string
  tooltip?: string
  theme?: keyof typeof themes
}
